import React from "react"
import {
  ListItem, Text, Image, UnorderedList, Flex,
} from "@chakra-ui/react"
import Link from "components/elements/Link"
import Icon from "components/elements/Icon"

type Props = {
  response: string[] | {file: string, type: string, url: string}
}

const FormSubmissionResponses = ({ response }: Props) => {
  if (Array.isArray(response)) {
    return (
      <UnorderedList>
        {response.map((answer) => (
          <ListItem color="blue.400">
            <Text>{typeof answer === "string" && answer}</Text>
          </ListItem>
        ))}
      </UnorderedList>
    )
  }

  if (typeof response === "object" && response.url) {
    const isImage = response.type && response.type.startsWith("image")

    return (
      <Link href={response.url} target="_blank" display="block">
        {isImage ? (
          <Image maxH="250px" h="full" alt={response.file} src={response.url} borderRadius="md" mt={2} />
        ) : (
          <Flex align="center" gap={1}>
            <Icon icon="form-attachment" size={6} color="blue.400" />
            <Text color="blue.400">{response.file}</Text>
          </Flex>
        )}
      </Link>
    )
  }

  return null
}

export default FormSubmissionResponses
